import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import styled from "styled-components";
import { MODAL_STYLES } from "./Table/constants";

const ModalHeader = styled.div`
  background: #ce0e2d;
  color: white;
  padding: 14px 20px;
  font-weight: 700;
  font-size: 1em;
`;

const ModalBody = styled.div`
  padding: 20px 20px 24px;
  text-align: center;
`;

const BodyText = styled.p`
  margin: 0 0 14px;
  line-height: 1.6;
  font-size: 0.95em;
  color: #333;
`;

const Countdown = styled.div`
  font-size: 2em;
  font-weight: 700;
  color: #ce0e2d;
  font-variant-numeric: tabular-nums;
`;

const ButtonRow = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: center;
  gap: 24px;
`;

const ConfirmBtn = styled.button`
  background: #ce0e2d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 22px;
  font-size: 0.9em;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #a30b24;
  }
`;

const SecondaryBtn = styled.button`
  background: white;
  color: #555;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px 22px;
  font-size: 0.9em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #f3f4f6;
    border-color: #999;
    color: #333;
  }
`;

// Format seconds as M:SS (e.g., 4:07).
const formatCountdown = (totalSeconds) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

const InactivityWarningModal = ({ isOpen, secondsRemaining, onStay, onLogoutNow }) => (
  <ReactModal
    isOpen={isOpen}
    style={MODAL_STYLES}
    appElement={document.getElementById("root")}
    shouldCloseOnOverlayClick={false}
    shouldCloseOnEsc={false}
  >
    <ModalHeader>Are you still there?</ModalHeader>
    <ModalBody>
      <BodyText>
        You&apos;ll be signed out due to inactivity. Click &ldquo;Stay signed
        in&rdquo; to continue your session.
      </BodyText>
      <Countdown aria-live="polite">{formatCountdown(secondsRemaining)}</Countdown>
    </ModalBody>
    <ButtonRow>
      <SecondaryBtn onClick={onLogoutNow}>Sign out now</SecondaryBtn>
      <ConfirmBtn onClick={onStay}>Stay signed in</ConfirmBtn>
    </ButtonRow>
  </ReactModal>
);

InactivityWarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  secondsRemaining: PropTypes.number.isRequired,
  onStay: PropTypes.func.isRequired,
  onLogoutNow: PropTypes.func.isRequired,
};

export default InactivityWarningModal;
